import React from 'react';
import { BlockDataForm, SidebarPortal } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import HeaderView from './View';
import Schema, { DEFAULTS } from './EditSchema';

const HeaderEdit = (props) => {
  const { data = {}, block, onChangeBlock, selected } = props;

  React.useEffect(() => {
    const next = { ...DEFAULTS, ...data };
    if (JSON.stringify(next) !== JSON.stringify(data)) {
      onChangeBlock(block, next);
    }
  }, []);

  return (
    <>
      <HeaderView data={data} isEditMode />

      <SidebarPortal selected={selected}>
        <BlockDataForm
          title={Schema(props).title}
          schema={Schema(props)}
          formData={data}
          onChangeField={(id, value) =>
            onChangeBlock(block, { ...data, [id]: value })
          }
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(HeaderEdit);
